import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsBasBuildingsList from "../created-list-inner-pages/tms-sm-bas-buildings-list";
import TmsBasCreation from "../creation-inner-pages/tms-bas-creation";
const BuildingIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Building Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsBasBuildingsList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Building Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsBasCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default BuildingIndex;
